export const apiPath = '/v1/attachments';
const actionType = 'ATTACHMENT';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
